// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"3c2eb67b","468":"29392cf2","484":"0e0a66b2","729":"9adfe488","934":"3aade2a1"}[chunkId] + ".chunk.js";
};